import p from "./_MapCache.js";
import h from "./_setCacheAdd.js";
import r from "./_setCacheHas.js";
function e(t) {
  var o = -1, a = t == null ? 0 : t.length;
  for (this.__data__ = new p(); ++o < a; )
    this.add(t[o]);
}
e.prototype.add = e.prototype.push = h;
e.prototype.has = r;
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_SetCache.js
// module id = 1456
// module chunks = 67